import { render, staticRenderFns } from "./overallseo.vue?vue&type=template&id=ece9c508&scoped=true"
import script from "./overallseo.vue?vue&type=script&lang=js"
export * from "./overallseo.vue?vue&type=script&lang=js"
import style0 from "./overallseo.vue?vue&type=style&index=0&id=ece9c508&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece9c508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ece9c508')) {
      api.createRecord('ece9c508', component.options)
    } else {
      api.reload('ece9c508', component.options)
    }
    module.hot.accept("./overallseo.vue?vue&type=template&id=ece9c508&scoped=true", function () {
      api.rerender('ece9c508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seo/overallseo.vue"
export default component.exports